module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title310"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429922906_tp01",
      "id": "toctitle307",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429922906_fm01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PREFACE")])])]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429922906_p01",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART I")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c01",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INTRODUCTION")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c01#title4",
      "id": "toctitle4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WASHINGTON, DC")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c01#title5",
      "id": "toctitle5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A SECOND CHANCE")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c02",
      "id": "toctitle6"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE POW HOSTAGE PLAN AND ITS IMPLEMENTATION")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c02#title7",
      "id": "toctitle7"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE HOSTAGE PLAN")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c02#title8",
      "id": "toctitle8"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HANOI’S PLAN TO CAPTURE AMERICANS ALIVE IN THE SOUTH")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c02#title9",
      "id": "toctitle9"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE QUALITY OF THE INTELLIGENCE •")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE QUALITY OF THE PAVN AS INTELLIGENCE SOURCES")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c02#title10",
      "id": "toctitle10"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("VIETCONG POLICY RELATING TO THE CAPTURE AND TREATMENT OF AMERICAN SERVICEMEN")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c03",
      "id": "toctitle11"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("HANOI BOUND")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c03#title12",
      "id": "toctitle12"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE MOVE NORTH")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c03#title13",
      "id": "toctitle13"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SOME AMERICAN POWs REMAIN IN CAMPS IN THE SOUTH")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c04",
      "id": "toctitle14"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("AMERICAN POWs CAPTURED BY THE PATHET LAO")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c04#title15",
      "id": "toctitle15"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE PRISONERS IN SAM NEUA")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c05",
      "id": "toctitle16"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("AMERICAN POWs IN NORTH VIETNAM")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c05#title17",
      "id": "toctitle17"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE IMPRISONMENT AND EXPLOITATION OF AMERICAN POWs IN NORTH VIETNAM")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c05#title18",
      "id": "toctitle18"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE AMERICANS AT HANOI’S HOA LO PRISON AND AT THE HOA LO CENTER")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c05#title19",
      "id": "toctitle19"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE HUMAN SHIELDS")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c06",
      "id": "toctitle25"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 5")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1972 THE WAR DRAWS TO A CLOSE")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c06#title26",
      "id": "toctitle26"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NORTH VIETNAMESE DECIDE TO SETTLE •")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("LE DUC THO AND HENRY KISSINGER AGREE ON A PEACE TREATY")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c06#title27",
      "id": "toctitle27"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“TO BE OR NOT TO BE”")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c06#title28",
      "id": "toctitle28"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“WE BELIEVE THAT PEACE IS AT HAND”")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c06#title29",
      "id": "toctitle29"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE PARIS NEGOTIATIONS")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c06#title30",
      "id": "toctitle30"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NIXON DECIDES TO SETTLE")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c06#title31",
      "id": "toctitle31"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE PARIS NEGOTIATIONS")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c06#title32",
      "id": "toctitle32"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("OPERATION LINEBACKER II •")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE B-52s")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("POUND HANOI, HAIPHONG, AND THE NORTH VIETNAMESE HEARTLAND")])])]), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429922906_p02",
      "id": "toctitle33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("PART II")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c07",
      "id": "toctitle34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 6")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("JANUARY 1973 PEACE AT A VERY HIGH PRICE")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c07#title35",
      "id": "toctitle35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PARIS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c07#title36",
      "id": "toctitle36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NORTH VIETNAM’S DEMANDS FOR WAR DAMAGES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c07#title37",
      "id": "toctitle37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WHAT AND HOW MUCH? THE LONG AND TORTURED DEBATE OVER THE FORM AND AMOUNT OF WAR DAMAGES TO BE PAID TO THE NORTH VIETNAMESE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c07#title38",
      "id": "toctitle38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NORTH VIETNAM’S FINAL BILL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c07#title39",
      "id": "toctitle39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HOW MANY? THE LONG AND TORTURED DEBATE OVER THE NUMBER OF AMERICANS HELD PRISONER BY THE COMMUNISTS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c07#title40",
      "id": "toctitle40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE PARIS ACCORDS ARE SIGNED •")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NORTH VIETNAMESE TURN OVER THE FIRST LIST OF POWs")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c07#title41",
      "id": "toctitle41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NIXON LETTER IS DELIVERED •")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NORTH VIETNAMESE TURN OVER THE SECOND LIST OF POWs")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c07#title42",
      "id": "toctitle42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“STUNNED,” “SHOCKED,” “INCONCEIVABLE,” “MY GOD, LOOK AT THE DISPARITY”")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c08",
      "id": "toctitle43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 7")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("FEBRUARY 1973 A HISTORIC JOURNEY TO HANOI")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c08#title44",
      "id": "toctitle44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE KISSINGER/PHAM VAN DONG MEETINGS IN HANOI")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c09",
      "id": "toctitle45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 8")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("FEBRUARY—MARCH 1973 THE “MOST TORTURED” ISSUE, “THE TOUGHEST SALE”")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c09#title46",
      "id": "toctitle46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE “MOST TORTURED” ISSUE, “THE TOUGHEST SALE”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c09#title47",
      "id": "toctitle47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NORTH VIETNAM CONVENES SPECIAL SESSION OF NATIONAL ASSEMBLY TO RATIFY PARIS ACCORDS, U.S. PLAN TO REBUILD NORTH")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c09#title48",
      "id": "toctitle48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NIXON, KISSINGER, ROGERS, DEFENSE OFFICIALS PUSH FOR CONGRESSIONAL APPROVAL OF RECONSTRUCTION AID TO NORTH VIETNAM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c09#title49",
      "id": "toctitle49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE U.S.-DRV JOINT ECONOMIC COMMISSION CONVENES IN PARIS •")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE DRV PRESENTS ITS FIVE-YEAR PLAN")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c10",
      "id": "toctitle50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 9")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("MID- TO LATE MARCH 1973 THE RETURNEE DEBRIEFS TELL OF HUNDREDS OF AMERICAN POWs HELD BACK")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c10#title51",
      "id": "toctitle51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE MID- AND LATE MARCH INTELLIGENCE AND OTHER INFORMATION FROM SOUTHEAST ASIA ABOUT UNLISTED POWs")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c10#title52",
      "id": "toctitle52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WHAT THE RETURNEES HAD TOLD ABOUT UNLISTED AMERICAN PRISONERS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c10#title53",
      "id": "toctitle53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE RETURNEES’ PERSONAL HISTORIES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c10#title54",
      "id": "toctitle54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE COMPARISONS PROVE DEVASTATING")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c11",
      "id": "toctitle55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 10")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("SPRING 1973 “A ‘CANCER’ ON THE PRESIDENCY”")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c11#title56",
      "id": "toctitle56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE WATERGATE BURGLARS ARE SENTENCED")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c11#title57",
      "id": "toctitle57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("McCORD FINGERS DEAN • NIXON NOW EXPOSED")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c11#title58",
      "id": "toctitle58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A MATTER OF SCHEDULING?")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c11#title59",
      "id": "toctitle59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GETTING VIETNAM OUT OF THE WAY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c11#title60",
      "id": "toctitle60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("POWs REPORTED ALIVE IN SOUTHEAST ASIA")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c11#title61",
      "id": "toctitle61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“IT IS BETTER … TO BE CERTAIN … THAN IT IS TO BE UNCERTAIN”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c11#title62",
      "id": "toctitle62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“THERE WAS NO CHOICE BUT TO FOLLOW HIS DIRECTIVE”")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c12",
      "id": "toctitle63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 11")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("SPRING, SUMMER, AND FALL 1973 THE COLLAPSE OF THE JEC TALKS • THE COLLAPSE OF THE PARIS PEACE ACCORDS")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c12#title64",
      "id": "toctitle64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BREAKING THE BAD NEWS TO THE NORTH VIETNAMESE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c12#title65",
      "id": "toctitle65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ENTER COMRADE FIDEL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c12#title66",
      "id": "toctitle66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NORTH VIETNAMESE MOVE TO TAKE THE SOUTH BY FORCE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c12#title67",
      "id": "toctitle67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A REMARKABLE CASE OF POOR TIMING")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c12#title68",
      "id": "toctitle68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A DRAMATIC, LAST-MINUTE AMERICAN EFFORT TO SAVE THE SOUTH AND THE UNLISTED, UNRETURNED POWs AS WELL")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c13",
      "id": "toctitle69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 12")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1974 THE END OF THE LINE FOR RICHARD NIXON")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c14",
      "id": "toctitle70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 13")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("JANUARY–APRIL 1975 THE END OF THE LINE FOR SOUTH VIETNAM")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c14#title71",
      "id": "toctitle71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CENTRAL HIGHLANDS CAMPAIGN BEGINS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c14#title72",
      "id": "toctitle72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CAMPAIGN TO TAKE SAIGON BEGINS")])])]), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429922906_p03",
      "id": "toctitle73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART III")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c15",
      "id": "toctitle74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 14")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("MAY–DECEMBER 1975 “CUBA SUGGESTED TO US TO KEEP THEM BACK” • CONGRESS INVESTIGATES THE FATE OF THE POWs AND MIAS")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c15#title75",
      "id": "toctitle75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NORTH VIETNAMESE EFFORT TO RANSOM THE UNLISTED, UNRETURNED POWS “CUBAN STYLE” FOR THE BILLIONS OF DOLLARS OF RECONSTRUCTION AID PROMISED THEM AT PARIS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c15#title76",
      "id": "toctitle76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("U.S. HOUSE CREATES SELECT COMMITTEE TO INVESTIGATE FATE OF POWs/MIAs")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c15#title77",
      "id": "toctitle77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MONTGOMERY GOES TO WORK")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c15#title78",
      "id": "toctitle78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HANOI")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c15#title79",
      "id": "toctitle79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A ROUGH CHRISTMAS FOR FOUR OTHER AMERICANS")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c16",
      "id": "toctitle80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 15")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1976 MONTGOMERY CONTINUES HIS INVESTIGATION • AMERICAN POWs SEEN IN CAPTIVITY IN BOTH NORTH AND SOUTH VIETNAM")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c16#title81",
      "id": "toctitle81",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE DEVASTATING TESTIMONY OF THE EXPERT WITNESSES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c16#title82",
      "id": "toctitle82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SOUTHERN VIETNAM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c16#title83",
      "id": "toctitle83",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE MASS TRANSFER OF REEDUCATION CAMP INMATES TO NORTHERN VIETNAM FOR LONG-TERM IMPRISONMENT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c16#title84",
      "id": "toctitle84",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE SOUTHERNERS BEGIN SEEING AMERICAN POWS NEAR THE REEDUCATION CAMPS OF NORTH VIETNAM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c16#title85",
      "id": "toctitle85",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NORTHERNERS ALSO SEE AMERICAN POWs")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c16#title86",
      "id": "toctitle86",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WASHINGTON")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c16#title87",
      "id": "toctitle87",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MONTGOMERY COMMITTEE WRAPS UP ITS INVESTIGATION, DECLARES ALL POWS/MIAs DEAD")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c17",
      "id": "toctitle88",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 16")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1977 A NEW PRESIDENT ADDRESSES THE MATTER OF THE UNLISTED, UNRETURNED POWs")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c17#title89",
      "id": "toctitle89",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WASHINGTON")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c17#title90",
      "id": "toctitle90",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“THE WHOLE POINT … WAS TO DECLARE … THE MIAs … DEAD”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c17#title91",
      "id": "toctitle91",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CIA INTELLIGENCE OF MARCH 8")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c17#title92",
      "id": "toctitle92",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HANOI")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c17#title93",
      "id": "toctitle93",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CIA INTELLIGENCE OF MARCH 16")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c17#title94",
      "id": "toctitle94",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WOODCOCK REPORTS HIS FINDINGS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c17#title95",
      "id": "toctitle95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PARIS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c17#title96",
      "id": "toctitle96",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“WE STAND FOR AN OVER-ALL, PACKAGE DEAL SOLUTION”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c17#title97",
      "id": "toctitle97",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GETTING OUT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c17#title98",
      "id": "toctitle98",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("VIETNAM")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c18",
      "id": "toctitle99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 17")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1978 THE SIGHTINGS OF THE UNLISTED, UNRETURNED POWs CONTINUE • THE REFUGEE EXODUS BEGINS")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c18#title100",
      "id": "toctitle100",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE SIGHTINGS OF THE UNLISTED, UNRETURNED POW CONTINUE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c18#title101",
      "id": "toctitle101",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MORE SIGHTINGS IN THE SOUTH")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c18#title102",
      "id": "toctitle102",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("STILL MORE SIGHTINGS IN THE NORTH")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c18#title103",
      "id": "toctitle103",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE REFUGEE EXODUS BEGINS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c18#title104",
      "id": "toctitle104",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE PERSECUTION OF THE ETHNIC CHINESE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c18#title105",
      "id": "toctitle105",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FIRST COME THE HOA, THEN THE SOUTHERN VIETNAMESE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c18#title106",
      "id": "toctitle106",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE REPORTS OF IMPRISONED AMERICANS BEGIN MAKING THEIR WAY TO THE U.S. GOVERNMENT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c18#title107",
      "id": "toctitle107",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE VIETNAMESE INVASION OF CAMBODIA")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c19",
      "id": "toctitle108",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 18")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1979 A PRISON SYSTEM IN CHAOS • CONVINCING EVIDENCE FINALLY REACHES WASHINGTON")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c19#title109",
      "id": "toctitle109",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CHINESE INVADE … AND THEN QUICKLY WITHDRAW")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c19#title110",
      "id": "toctitle110",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE RELOCATION OF THE DISPLACED AMERICAN POWS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c19#title111",
      "id": "toctitle111",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("OTHER AMERICAN POWS REMAIN CAPTIVE IN THE NORTH")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c19#title112",
      "id": "toctitle112",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("U.S. OFFICIALS BECOME CONVINCED POWs ARE ALIVE IN SOUTHEAST ASIA")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c19#title113",
      "id": "toctitle113",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("REPORT 1: THE ETHNIC CHINESE MORTICIAN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c19#title114",
      "id": "toctitle114",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("REPORT 2: THE FORMER ARVN COLONEL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c19#title115",
      "id": "toctitle115",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("REPORT 3: THE PRIZED DEFECTOR")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c19#title116",
      "id": "toctitle116",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE RADIO INTERCEPT TELLING OF THE TRANSFER OF AMERICAN AND THAI POWs WITHIN LAOS ON NOVEMBER 15, 1979")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c20",
      "id": "toctitle117",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 19")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1980 RESCUE PLANS")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c20#title118",
      "id": "toctitle118",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE AMERICAN POWS AT CAMP K-55, TAY NINH PROVINCE, VIETNAM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c20#title119",
      "id": "toctitle119",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE AMERICAN PRISONERS AT GNOMMORATH, LAOS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c20#title120",
      "id": "toctitle120",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FRESH SIGINT TELLING OF AMERICAN POWs ALIVE IN LAOS")])])]), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429922906_p04",
      "id": "toctitle121",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("PART IV")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c21",
      "id": "toctitle122",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 20")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1981 “GASOLINE”")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c21#title123",
      "id": "toctitle123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DELTA FORCE/JOINT SPECIAL OPERATIONS COMMAND • OPERATION POCKET CHANGE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c21#title124",
      "id": "toctitle124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CIA GROUND RECONNAISSANCE MISSION TO FORT APACHE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c21#title125",
      "id": "toctitle125",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“WE DIDN’T WANT TO PUT GASOLINE ON THE ISSUE”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c21#title126",
      "id": "toctitle126",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MORE PUBLICITY ABOUT THE POWs AND A NEW EFFORT TO FREE THEM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c21#title127",
      "id": "toctitle127",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A FINAL INTELLIGENCE UPDATE BEFORE DEPARTURE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c21#title128",
      "id": "toctitle128",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IMPLEMENTING THE PLAN")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c22",
      "id": "toctitle129",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 21")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1982 “THE PRINCIPLE OF RECIPROCITY”")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c22#title130",
      "id": "toctitle130",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GETTING THE WORD TO THE PRESIDENT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c22#title131",
      "id": "toctitle131",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“BIGGER THAN THE RED SEA”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c22#title132",
      "id": "toctitle132",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“SOME PEOPLE BELIEVE THE TIGERS ATE ALL YOUR MEN …”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c22#title133",
      "id": "toctitle133",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE ADMINISTRATION CHANGES OFFICIAL POLICY ON LIVING POWs")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c22#title134",
      "id": "toctitle134",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“REHABILITATION OF PEOPLE’S LIVELIHOOD”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c22#title135",
      "id": "toctitle135",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A PROPOSAL FROM THE LAO")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c22#title136",
      "id": "toctitle136",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WASHINGTON")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c23",
      "id": "toctitle137",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 22")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1983 A DRAMATIC CHANGE OF COURSE")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c23#title138",
      "id": "toctitle138",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE WAR HERO, CLINT EASTWOOD, WILLIAM SHATNER, AND THE PRESIDENT OF THE UNITED STATES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c23#title139",
      "id": "toctitle139",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE END OF THE LAO INITIATIVE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c23#title140",
      "id": "toctitle140",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THREE LAST ATTEMPTS TO RESTART THE LAO INITIATIVE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c23#title141",
      "id": "toctitle141",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE ADMINISTRATION’S NEW PLAN FOR DEALING WITH THE POWs")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c23#title142",
      "id": "toctitle142",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE SHIFT TO REMAINS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c23#title143",
      "id": "toctitle143",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CENTRAL AMERICA")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c24",
      "id": "toctitle144",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 23")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1984 TRAGEDY AT ARLINGTON • A MISSED OPPORTUNITY IN THE OVAL OFFICE")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c24#title145",
      "id": "toctitle145",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE FRAUDLENT SELECTION OF THE UNKNOWN SOLDIER")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c24#title146",
      "id": "toctitle146",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE SELECTION OF LT. MICHAEL BLASSIE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c24#title147",
      "id": "toctitle147",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CEREMONIES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c24#title148",
      "id": "toctitle148",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MOVING ON")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c24#title149",
      "id": "toctitle149",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE REEMERGENCE OF ROBERT GARWOOD")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c24#title150",
      "id": "toctitle150",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“I WANT TO CLEAR MY CONSCIENCE AND HELP THESE MEN”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c24#title151",
      "id": "toctitle151",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A CALIFORNIA CONGRESSMAN CONFRONTS HIS PRESIDENT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c24#title152",
      "id": "toctitle152",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE POW SPECIAL OFFICE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c24#title153",
      "id": "toctitle153",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ONE LAST TRY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c24#title154",
      "id": "toctitle154",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NEW YEAR’S RESOLUTIONS")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c25",
      "id": "toctitle155",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 24")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1985 “PROGRESS” IN THE SEARCH FOR REMAINS • FRESHMEN, STONEWALLED ON POWs, TURN TO PEROT • McFARLANE DROPS HIS GUARD")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title156",
      "id": "toctitle156",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SHOWING PROGRESS ON REMAINS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title157",
      "id": "toctitle157",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EXCAVATION OF THE CRASH SITE BEGINS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title158",
      "id": "toctitle158",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PURCHASING BONES FOR CASH FROM THE NORTH VIETNAMESE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title159",
      "id": "toctitle159",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE DIA “INTERNAL REVIEW”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title160",
      "id": "toctitle160",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("STONEWALLING THE CONGRESSMEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title161",
      "id": "toctitle161",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SPECTRE 17, THE VERDICT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title162",
      "id": "toctitle162",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A RENEWED EFFORT TO GAIN ACCESS TO THE DIA FILES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title163",
      "id": "toctitle163",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("McFARLANE DROPS HIS GUARD")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title164",
      "id": "toctitle164",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A BRIEF ENCOUNTER WITH MAJ. GEN. POWELL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title165",
      "id": "toctitle165",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE TRUTH ABOUT THE SPECTRE 17 IDS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c25#title166",
      "id": "toctitle166",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE PUBLIC DEBATE OVER LIVE POWs CONTINUES")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c26",
      "id": "toctitle167",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 25")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1986 TRENCH WARFARE")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title168",
      "id": "toctitle168",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“RESPECTFULLY, MR. PRESIDENT, IS IT TRUE?”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title169",
      "id": "toctitle169",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GOOD NEWS AND BAD NEWS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title170",
      "id": "toctitle170",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“THE DIRECTOR’S PW/MIA TASK FORCE REVIEW OF THE PW/MIA DIVISION”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title171",
      "id": "toctitle171",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE TIGHE VERDICT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title172",
      "id": "toctitle172",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE WHITE HOUSE MOVES TO CHANGE THE TIGHE REPORT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title173",
      "id": "toctitle173",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PERROOTS AND HIS MEN HEAD SOUTH, NEVER TO RETURN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title177",
      "id": "toctitle177",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DAMAGE CONTROL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title178",
      "id": "toctitle178",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE DCI’S CANDID ASSESSMENT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title179",
      "id": "toctitle179",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROSS PEROT, LONGTIME FRIEND OF THE INDOCHINA POWs")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title180",
      "id": "toctitle180",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE VOTE ON THE PEROT BILL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title181",
      "id": "toctitle181",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ANOTHER HOSTAGE RELEASED IN LEBANON • A CLOSE ELECTION • IRAN-CONTRA EXPLODES IN THE PRESS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title182",
      "id": "toctitle182",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IN THE MIDST OF THE MAELSTROM, THE INDOCHINA POWs ARE NOT FORGOTTEN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c26#title183",
      "id": "toctitle183",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PEROT CONCLUDES HIS STUDY AND PREPARES HIS RECOMMENDATIONS")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c27",
      "id": "toctitle184",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 26")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1987 PEROT TO HANOI • A BOMBSHELL FROM GENERAL VESSEY • NO EVIDENCE?")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c27#title185",
      "id": "toctitle185",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THACH AND PEROT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c27#title186",
      "id": "toctitle186",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DALLAS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c27#title187",
      "id": "toctitle187",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MEANWHILE, THREE NEW INITIATIVES AIMED AT GETTING THE POWs HOME")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c27#title188",
      "id": "toctitle188",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WASHINGTON • AMBUSH IN THE OVAL OFFICE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c27#title189",
      "id": "toctitle189",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE ADMINISTRATION REACTS TO THE NEW INITIATIVES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c27#title190",
      "id": "toctitle190",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SHULTZ REJECTS A “TWO WAY STREET” • VESSEY DEPARTS FOR HANOI")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c27#title191",
      "id": "toctitle191",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HANOI")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c27#title192",
      "id": "toctitle192",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("VESSEY DROPS “LIVE MIA” BOMBSHELL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c27#title193",
      "id": "toctitle193",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A BIG DOSE OF COLD WATER FROM LANGLEY: • “NO CREDIBLE EVIDENCE OF LIVE POWs")]), _c('strong', {
    staticClass: "b"
  }, [_vm._v(",” CIA RESPONDS, NO “PLAUSIBLE MOTIVE” FOR HANOI TO KEEP THEM")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c27#title194",
      "id": "toctitle194",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NGOs TAKE CENTER STAGE")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c28",
      "id": "toctitle195",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 27")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1988 “JUST TWO BAR OF SILVERS FOR EACH MAN”")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c28#title196",
      "id": "toctitle196",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HEARINGS HELD ON SMITH’S BILL TO DECLASSIFY THE POW INTELLIGENCE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c28#title197",
      "id": "toctitle197",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("REAGAN TO FAMILIES: WE WILL NOT PAY FOR LIVE PRISONERS, BUT WE WILL ACCELERATE THE SEARCH FOR BONES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c28#title198",
      "id": "toctitle198",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NORTHEAST THAILAND")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c28#title199",
      "id": "toctitle199",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WASHINGTON")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c28#title200",
      "id": "toctitle200",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE REAGAN ADMINISTRATION’S FINAL REPORT ON THE POW/MIA ISSUE")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c29",
      "id": "toctitle201",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 28")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1989 “ … THE STATUTE OF LIMITATIONS HAS BEEN REACHED”")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c29#title202",
      "id": "toctitle202",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("RATCHETING UP THE REWARD")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c29#title203",
      "id": "toctitle203",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MORE “CONSTERNATION”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c29#title204",
      "id": "toctitle204",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE MT. BIA OUTRAGE IS ECLIPSED")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c29#title205",
      "id": "toctitle205",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WHAT TO DO?")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c29#title206",
      "id": "toctitle206",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A PERSONAL PLEA TO THE PRESIDENT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c29#title207",
      "id": "toctitle207",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE WHITE HOUSE RESPONDS")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c30",
      "id": "toctitle208",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 29")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1990 SABOTAGING THE HELMS/GRASSLEY INVESTIGATIONS • THE BUSH FINAL REPORT ON POWs • THACH’S HISTORIC VISIT TO WASHINGTON")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c30#title209",
      "id": "toctitle209",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CLEARING THE DECKS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c30#title210",
      "id": "toctitle210",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DIA SOURCE 0995")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c30#title211",
      "id": "toctitle211",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A QUICK TRIP TO THE HILL TO BUY TIME")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c30#title212",
      "id": "toctitle212",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GARWOOD’S FIVE SIGHTINGS SIGHTINGS #4979, 4980, 4981, 4982, AND 4983")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c30#title213",
      "id": "toctitle213",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE REMAINING EYEWITNESS SIGHTINGS FROM HA NAM NINH BA SAO/ROCKPILE •")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("DIA SOURCES #8666 AND #10721")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c30#title214",
      "id": "toctitle214",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MEANWHILE, STUNNING NEW INTELLIGENCE ON AN UNDERGROUND PRISON NORTHWEST OF HANOI")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c30#title215",
      "id": "toctitle215",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE BUSH ADMINISTRATION FINAL REPORT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c30#title216",
      "id": "toctitle216",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SHOVING, SHOUTING MATCH BREAKS OUT AT LEAGUE CONVENTION • COURTS-MARTIAL EFFORT BEGINS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c30#title217",
      "id": "toctitle217",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NGUYEN CO THACH MAKES UNPRECEDENTED VISIT TO WASHINGTON, DECLARES")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AGAIN")])]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THAT AMERICANS MAY BE ALIVE IN WILD AREAS OF HIS COUNTRY • HELMS ISSUES EXPLOSIVE INTERIM REPORT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c30#title218",
      "id": "toctitle218",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CIRCLING THE WAGONS")])])]), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429922906_p05",
      "id": "toctitle219",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("PART V")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c31",
      "id": "toctitle220",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 30")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1991 ONE LAST CHANCE TO SAVE THE UNLISTED, UNRETURNED POWS")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c31#title221",
      "id": "toctitle221",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A NEW INITIATIVE IN THE U.S. SENATE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c31#title222",
      "id": "toctitle222",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A MESSAGE ON THE OFFICE DOOR")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c31#title223",
      "id": "toctitle223",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE HELMS FINAL REPORT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c31#title224",
      "id": "toctitle224",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A DOD INFORMANT’S DUBIOUS PHOTOGRAPH TURNS THE TIDE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c31#title225",
      "id": "toctitle225",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ONE LAST CHANCE TO SAVE THE UNLISTED, UNRETURNED POWs")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c32",
      "id": "toctitle226",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 31")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1992 THE FRAGGING")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title227",
      "id": "toctitle227",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE JANUARY PERSONNEL CHANGES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title228",
      "id": "toctitle228",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE TOURISON REVELATIONS AND THE CHAIRMAN’S ROAD MAP")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title229",
      "id": "toctitle229",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE INVESTIGATION OF THE INTELLIGENCE BEGINS AT LAST •")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("THE HOWS, WHYS, AND WHEREFORES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title230",
      "id": "toctitle230",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE APRIL 9, 1992, INTELLIGENCE FINDING")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title231",
      "id": "toctitle231",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("U.S. CAPITOL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title232",
      "id": "toctitle232",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“WHO’S GOING TO KNOW? IS SOMEBODY GOING TO LEAK IT?”")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title233",
      "id": "toctitle233",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CHAIRMAN’S STRANGE, NEWFOUND INTEREST IN THE CLUSTER BRIEFING")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title234",
      "id": "toctitle234",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SENATOR KERRY DRIVING THE PROCESS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title235",
      "id": "toctitle235",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HANOI")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title236",
      "id": "toctitle236",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HANOI")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title237",
      "id": "toctitle237",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WASHINGTON")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title238",
      "id": "toctitle238",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MEMORIAL DAY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title239",
      "id": "toctitle239",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE INVESTIGATORS RESPOND WITH THREE NEW INITIATIVES: CONDUCTING ON-SITE PRISON INVESTIGATIONS THEMSELVES, BRIEFING THE “McCAIN CLUSTER,” AND OFFICIALLY ESTIMATING THE NUMBER OF POWs STILL ALIVE IN VIETNAM AND LAOS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title240",
      "id": "toctitle240",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAOS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title241",
      "id": "toctitle241",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JOHN KERRY, DRIVING DOWN THE NUMBERS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title242",
      "id": "toctitle242",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE INTELLIGENCE HEARINGS BEGIN")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title243",
      "id": "toctitle243",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE HO CHI MINH MAUSOLEUM, THE UNDERGROUND PRISON, AND THE MND CITADEL")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title244",
      "id": "toctitle244",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ONE HELL OF A CLUSTER")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title245",
      "id": "toctitle245",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE RUSSIAN AMBASSADOR")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title246",
      "id": "toctitle246",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE DEFENSE NUCLEAR AGENCY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title247",
      "id": "toctitle247",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EXPLOSIVE NEW HUMINT ON THE UNDERGROUND PRISON AND THE MAN WHO REPORTEDLY SUPERVISED ITS CONSTRUCTION")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title248",
      "id": "toctitle248",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CODED MESSAGE FROM LIEUTENANT COLONEL SEREX")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title249",
      "id": "toctitle249",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE JOINT BUSH ADMINISTRATION/SENATE SELECT COMMITTEE ASSAULT ON THE POSTWAR IMAGERY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title250",
      "id": "toctitle250",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A DISCUSSION OF THE SAM NEUA “USA/WALKING K” E&E CODE ON")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DATELINE NBC")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title251",
      "id": "toctitle251",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE OCTOBER 15 IMAGERY HEARINGS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title252",
      "id": "toctitle252",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ELECTION DAY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title253",
      "id": "toctitle253",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE ENDGAME")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title254",
      "id": "toctitle254",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE LINGERING MATTER OF THE SECRET SERVICE AGENT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title255",
      "id": "toctitle255",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE FINAL HEARINGS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title256",
      "id": "toctitle256",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A TRIUMPHANT RETURN TO HANOI")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c32#title257",
      "id": "toctitle257",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WASHINGTON")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c33",
      "id": "toctitle258",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 32")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1993–1995 “THE VIETNAMESE KNOW HOW TO COUNT”")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c33#title259",
      "id": "toctitle259",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JANUARY 25, UNITED STATES SENATE")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c33#title260",
      "id": "toctitle260",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE UNLISTED, UNRETURNED POWs DO NOT GO QUIETLY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c33#title261",
      "id": "toctitle261",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE FURIOUS THREE-DAY DEBATE OVER THE RUSSIAN DOCUMENT")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c33#title262",
      "id": "toctitle262",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CLINTON’S HISTORIC DIRECTIVE TO VESSEY")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c33#title263",
      "id": "toctitle263",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("VESSEY CARRIES OUT HIS ORDERS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429922906_c33#title264",
      "id": "toctitle264",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE ROAD TO NORMALIZATION")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429922906_c34",
      "id": "toctitle265",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "u"
  }, [_vm._v("CHAPTER 33")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1995–2005 “WAR LEGACIES”")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429922906_bm01",
      "id": "toctitle266",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EPILOGUE")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A PROPOSAL FOR PRESIDENT BUSH")])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429922906_bm02",
      "id": "toctitle267",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("• A MESSAGE FROM THE AUTHORS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429922906_bm03",
      "id": "toctitle268",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("NOTES")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781429922906_ack01",
      "id": "toctitle305",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781429922906_ind01",
      "id": "toctitle306",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("INDEX")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429922906_cop01",
      "id": "toctitle308",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6026d374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429922906_toc01.vue
// module id = 63
// module chunks = 0